import React, { useState, useEffect } from "react"
import styled from "styled-components"
import { a, useTransition, useSpring } from "react-spring"

import FloorplanMobile from "./FloorplanMobile"
import CloseIcon from "assets/images/icons/close.svg"

import { APART_PROPS } from "dataset/finder"
import { availability } from "utils/convertDataFormat"
import Views from "./ViewsMobile"
import SpecsMobile from "./SpecsMobile"

function ShareCardMobile({ apartment, isOpen, action, direction, setSwiperActive }) {
  const [section, setSection] = useState("FLOORPLAN")
  const sections = ["FLOORPLAN", "VIEWS", "SPECS"]
  const parentAnm = useTransition(
    isOpen,
    direction
      ? {
          from: {
            opacity: 0,
            left: "0%",
          },
          enter: {
            opacity: 1,
            left: "50%",
            delay: 300,
          },
          leave: {
            opacity: 0,
            left: "100%",
          },
        }
      : {
          from: {
            opacity: 0,
            left: "100%",
          },
          enter: {
            opacity: 1,
            left: "50%",
            delay: 300,
          },
          leave: {
            opacity: 0,
            left: "0%",
          },
        },
  )

  const cardAnm = useSpring({
    from: {
      opacity: 1,
      top: "0%",
    },
    to: {
      opacity: 1,
      top: "50%",
    },
  })

  function handleClosing() {
    action(false)
    // return setTimeout(() => {
    //   setapartment(null)
    //   setFullCardOpen(true)
    //   setSection("FLOORPLAN")
    // }, 800)
  }

  function changeSection(sec) {
    setSection(sec)
  }

  useEffect(() => {
    setSwiperActive(section !== "VIEWS")
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [section])

  return parentAnm(
    (anm, loaded) =>
      loaded && (
        <Wrapper style={anm}>
          <Card style={cardAnm}>
            <span className="close">
              <Close
                onClick={() => {
                  handleClosing()
                }}>
                <img src={CloseIcon} alt="" />
              </Close>
            </span>
            <Header>
              <h1>
                <span>&#9826; </span>
                {apartment?.[APART_PROPS.unit]}
                <span> &#9826;</span>
              </h1>
              <h3>{apartment?.[APART_PROPS.unitType]}</h3>
              <h3 style={{ letterSpacing: "0.3rem" }}>
                {apartment && availability(apartment["Availability"], apartment[APART_PROPS.price])}
              </h3>
              <h3>
                {apartment?.[APART_PROPS.beds] === "1"
                  ? `${apartment?.[APART_PROPS.beds]} BED`
                  : `${apartment?.[APART_PROPS.beds]} BEDS`}
              </h3>
            </Header>
            <Sections>
              {sections.map((sect, i) => {
                return (
                  <Section
                    key={`sect${i}`}
                    selected={section === sect}
                    onClick={() => {
                      changeSection(sect)
                    }}>
                    {sect}
                  </Section>
                )
              })}
            </Sections>
            <Display>
              <FloorplanMobile section={section} apartment={apartment} />
              <Views section={section} apartment={apartment} />
              <SpecsMobile section={section} />
            </Display>
          </Card>
        </Wrapper>
      ),
  )
}

export default ShareCardMobile

const Wrapper = styled(a.div)`
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: black;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 5;

  & span {
    filter: drop-shadow(5px 5px 15px black);
    pointer-events: none;
  }

  .close {
    position: fixed;
    top: 0;
    right: 0;
    width: 20%;
    aspect-ratio: 1/1;
    pointer-events: all;
    z-index: 5;
  }
`

const Card = styled(a.div)`
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
`

const Header = styled.div`
  position: relative;
  left: 0;
  height: 20%;
  width: 100%;
  padding-bottom: 2%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #b58762;
  color: black;
  gap: 1em;

  & h1 {
    font-size: 8em;
    font-weight: 100;
    white-space: nowrap;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;

    & span {
      font-size: 0.3em;
      font-weight: 100;
    }
  }

  & h3 {
    text-align: center;
    text-transform: uppercase;
    font-size: 2em;
    font-weight: 100;

    :nth-of-type(1) {
      color: white;
      font-size: 2.5em;
    }
  }
`

const Display = styled.div`
  position: absolute;
  bottom: 2%;
  left: 50%;
  width: 90%;
  height: 70%;
  max-height: 70%;
  transform: translateX(-50%);
  overflow-y: auto;
  overflow-x: hidden;

  ::-webkit-scrollbar {
    display: none;
  }
`

const Close = styled.div`
  width: 100%;
  aspect-ratio: 1/1;
  clip-path: polygon(0% 0%, 100% 0%, 100% 100%);
  background-color: white;

  & img {
    position: absolute;
    top: 10%;
    right: 10%;
    z-index: 5;
    width: 35%;
    aspect-ratio: 1/1;
    border: 1px solid #b58762;
    border-radius: 100%;
    padding: 5%;
  }
`

const Sections = styled.div`
  width: 100%;
  height: 5%;
  background-color: white;
  pointer-events: all;
  touch-action: all;
`
const Section = styled.div`
  display: inline-grid;
  place-content: center;
  width: calc(100% / 3);
  height: 100%;
  font-size: 0.8rem;
  background-color: ${p => (p.selected ? "black" : "transparent")};
  color: ${p => (p.selected ? "#b58762" : "black")};
`
